import { useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { APP_ROUTES, NavigationLinkProps } from "../../providers/Router";

const flatten = (routes: NavigationLinkProps[]): NavigationLinkProps[] =>
  routes.flatMap((route) =>
    route.children && route.children.length > 0
      ? [route, ...flatten(route.children)]
      : [route]
  );

const useMobileAvailability = (): { isMobileAvailable: boolean } => {
  const { pathname } = useLocation();
  return useMemo(() => {
    // APP_ROUTES is read lazily inside the hook to avoid a load-order cycle
    // between Router.tsx (which imports every feature router) and the page
    // components that consume this hook via PageContainer.
    const flat = flatten(APP_ROUTES).filter(
      (route) => route.path && route.path !== "#"
    );
    const matched = flat.find((route) => matchPath(route.path, pathname));
    return { isMobileAvailable: matched?.mobileAvailable === true };
  }, [pathname]);
};

export default useMobileAvailability;
